import { UpdateTermineFormProps } from '@/domain/termine/features/UpdateTermin/shared/types';
import { useTranslation } from 'react-i18next';

type DatePickerFormFieldName = 'datum' | 'wiederholungBis';

interface DatePickerFormFieldProps extends UpdateTermineFormProps {
  name: DatePickerFormFieldName;
  disabled?: boolean;
}

export function DatePickerFormField({
  name,
  form,
  disabled,
}: DatePickerFormFieldProps) {
  const { t } = useTranslation();

  const label =
    name === 'datum'
      ? t('domain.termine.sheet.fields.am')
      : t('domain.termine.sheet.fields.laufzeitBis');

  return (
    <form.AppField name={name}>
      {(field) => <field.DatePicker label={label} disabled={disabled} />}
    </form.AppField>
  );
}
